export const CHECK_PREVIEW_ATTEMPTS_NUMBER = 7;
export const CHECK_PREVIEW_PAUSE = 1000; // one second
export const CHECKOUT_FLOW = 'checkout';
export const PACKAGES_FLOW = 'packages';
